<template>
  <div class="goods">
    <v-head :title="title" style="position: fixed;width: 100%;z-index: 999;" :route="'MemberCenter'"></v-head>
    <div class="content">
      <div class="order-box">
        <div style="text-align:center; padding:30px 0" v-if="loading">
          <van-loading size="24px" vertical>加载中...</van-loading>
        </div>
        <div v-else>
          <div class="warmTip" v-if="tableData.content && tableData.content.length<1">
            <img src="@/assets/images/404.png" />
            <span>暂无内容</span>
          </div>
          <ul v-else>
            <li class="box" v-for="item in tableData.content" :key="item.id">
              <div style="background-color: #fff;">
                <div>
                  <p class="title-p">
                    <span>提交申请时间&nbsp;&nbsp;&nbsp;&nbsp; {{item.applyTime}}</span>
                    <span v-if="item.result==4"><i style="color:#f9a153">待审核</i></span>
                    <span v-if="item.result==1"><i>审核通过</i></span>
                    <span v-if="item.result==3"><i style="color: #ff4542;">退回修改</i></span>
                  </p>
                </div>
                <div class="Order">
                  <div class="justify-content">
                    <span>变更前会员类型</span>
                    <span> {{getMemberType(item.originMemberType)}}</span>
                  </div>
                  <div class="justify-content">
                    <span>申请变更会员类型</span>
                    <span style="margin-left: 15px;"> {{getMemberType(item.upGradeMemberType)}}</span>
                  </div>
                  <div class="justify-content" v-if="item.result==1">
                    <span>审核通过时间</span>
                    <span style="margin-left: 15px;">{{item.auditSuccessTime}}</span>
                  </div>
                  <div @click="lookreason(item.reason)" class="reason" v-if="item.result==3">
                    <p>
                      退回原因：{{item.reason}}
                    </p>
                  </div>
                  <div class="buttonBox">
                    <p>
                      <van-button v-if="item.result==4||item.result==3" plain type="primary"
                        @click="edit(item)">修改重新提交</van-button>
                    </p>
                  </div>
                </div>
              </div>

            </li>
          </ul>
        </div>


      </div>
    </div>
    <div class="bottomButton">
      <el-button plain type="primary" @click="apply()">点击申请变更会员类型</el-button>
    </div>
  </div>
</template>
<script>
  import {
    getUser,
    singleCanUpgrade,
    upGradePage,
    downLoadFile,
    upGradeDetail
  } from "@/api/dictionary";
  import vHead from "../../components/Subhead.vue";
  import { getSessionStore } from "@/utils/sessionStorage.js";
  import {
    Uploader,
    Toast,
    Button,
    ImagePreview,
    ActionSheet,
    Dialog,
    Loading,
  } from "vant";
  import { mapGetters, mapState, mapMutations, mapActions } from "vuex";
  export default {
    data() {
      return {
        pay: false,
        loading: false,
        codeUrl: null,
        socket: null,
        dialogVisible: false,
        refresh: false,
        isShowPay: false,
        params: {
          pageSize: 10,
        },
        tableData: {

        },
        Id: '',
        page: 1,
        orderTip: "",
        payStatus: 0,
        checkedA: true,
        memberInfo: {},
        title: "变更申请记录",
        isWXPay: true,
        orderList: {
          content: [],
        },
        list: {
          content: [],
        },
        actived: 3,
        showBotton: false,
      };
    },
    components: {
      vHead,

      [Uploader.name]: Uploader,
      [Toast.name]: Toast,
      [Button.name]: Button,
      [ImagePreview.name]: ImagePreview,
      [ActionSheet.name]: ActionSheet,
      [Dialog.Component.name]: Dialog.Component,
      [Loading.name]: Loading,
    },
    computed: {
      ...mapGetters(["isGroupMember", "getMemberType"]),
      ...mapState(["userInfo"]),
    },
    methods: {
      ...mapActions([
        "getMemberTypeList",
      ]),
      ...mapMutations(["setMemberInfo"]),
      cancel() {

      },
      getData() {
        let params = { ...this.params }
        params.memberId = getSessionStore("memberId")
        params.memberCategory = this.userInfo.memberCategory
        upGradePage(params, this.page - 1).then(res => {
          if (res.success) {
            this.tableData = res.result
          }
        })
      },
      isWithinThreeMonths(userInfo) {
        // 获取当前日期  
        var now = new Date();
        // 获取expiryDate的年份、月份和日期  
        var expiryDate = new Date(userInfo.expiryDate);
        // 将expiryDate转换为与当前日期相同的年份和月份，以便进行比较  
        expiryDate = new Date(expiryDate.getFullYear(), expiryDate.getMonth(), expiryDate.getDate());

        // 计算三个月后的日期  
        var threeMonthsLater = new Date(now.getFullYear(), now.getMonth() + 1, now.getDate());
        console.log('expiryDate', expiryDate >= threeMonthsLater, expiryDate, threeMonthsLater)
        // 比较expiryDate和三个月后的日期  
        if (expiryDate >= threeMonthsLater) {
          return true; // 距离有效期超过三个月  
        } else {
          return false; // 距离有效期还有三个月或更少  
        }
      },

      lookreason(reason) {
        this.$confirm(reason, "退回原因", {
          cancelButtonText: '关闭',
          type: "",
          showConfirmButton: false,
          showCancelButton: false
        }).then(() => {
        }).catch(() => { });
      },
      edit(row) {
        upGradeDetail({ id: row.id }).then(res => {
          if (res.success) {
            this.$router.push({ name: 'changeInfo', params: res.result, query: { upGradeMemberType: row.upGradeMemberType, upGradeId: row.id } })
          }
        })
      },
      apply() {
        //有效期大于一个月不行
        let months = this.isWithinThreeMonths(this.userInfo)//是否大于1个月
        if (months) {
          this.$confirm("您当前的有效期大于一个月，不可申请会员类型变更。", "提示", {
            cancelButtonText: '关闭',
            type: "warning",
            showConfirmButton: false
          }).then(() => {
          }).catch(() => { });
        } else {
          let params = {
            memberId: this.userInfo.id,
            memberCategory: this.userInfo.memberCategory
          }
          singleCanUpgrade(params).then(res => {
            if (res.success) {
              let userInfo = { ...this.userInfo }
              this.$router.push({ name: 'changeInfo', params: userInfo })

            } else {
              this.$confirm(res.message, "提示", {
                cancelButtonText: '关闭',
                type: "warning",
                showConfirmButton: false
              }).then(() => {
              }).catch(() => { });
            }
          })
        }
      },

    },
    created() {
      this.getMemberTypeList()
    },
    mounted() {

      getUser().then((res) => {
        this.memberInfo = res.result;
        this.setMemberInfo(res.result);
      });
      this.getData()
    },
  };
</script>

<style lang="less" scoped>
  .content {
    margin-bottom: 70px;
    padding-top: 50px;
  }

  .warmTips {
    padding: 30px 0 40px 0;
  }

  .warmTips div>p {
    line-height: 22px;
    margin-bottom: 20px;
  }


  .reason {
    display: inline-block;
    padding: 10px;
    border-radius: 3px;
    background: rgb(255, 238, 238);
    width: 95%;
    margin-top: 5px;
  }


  .reason>p {
    color: rgba(234, 15, 15, 1) !important;
    word-wrap: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }


  .Order {
    padding: 15px;
  }

  .Order .justify-content {
    line-height: 30px;
    color: #4f4f4f;
    font-size: 14px;
  }

  .buttonBox {
    width: 100%;
    text-align: end;
    margin-top: 15px;
  }

  .title-p {
    padding: 15px 15px 0 15px;
    display: flex;
    justify-content: space-between;
  }

  .van-button {
    height: 28px !important;
  }

  .justify-content {
    display: flex;
    justify-content: space-between;
  }

  .bottomButton {
    width: 100%;
    position: fixed;
    bottom: 0;
    padding: 20px 0;
    text-align: center;
    background-color: #fff;
  }



  .box {
    padding-top: 10px;
    background-color: #efefef;
  }
</style>